import React from 'react'
import { GrClose } from 'react-icons/gr'
import { Text } from '../../../'
import { StyledClose, Container, TitleContainer, SubtitleContainer } from './index.styled'

export const HeaderMobileComponent = ({title = "", subtitle= "", onClose = () => {}}) => {
  return (
    <Container>
      <StyledClose onClick={() => onClose()}><GrClose /></StyledClose>
      <TitleContainer>
        <Text fontFamily="Amorim Sans" textId={title} />
      </TitleContainer>
      <SubtitleContainer>
        <Text fontFamily="Amorim Sans Book" textId={subtitle} />
      </SubtitleContainer>
    </Container>
  )
}
